import * as actionTypes from './actionTypes';
import { paymentService } from './services';
import { actionsModalError } from '@app/src/common/modalError';
import { isClientEnv } from '@app/src/utils/validations';
import { fetchValidate } from '@app/src/common/session';
import { fetchProcessConfirmPayment } from '@app/src/views/StepConfirm/sectionConfirm';

const isClient = isClientEnv();

const sendDataPaymentRequest = () => ({
  type: actionTypes.SEND_DATA_PAYMENT_REQUEST
});

const sendDataPaymentFailure = () => ({
  type: actionTypes.SEND_DATA_PAYMENT_FAILURE
});

const sendDataPaymentSuccess = (data: any) => ({
  type: actionTypes.SEND_DATA_PAYMENT_SUCCESS,
  data
});

const buildCulqiData = (dispatch, data, price, setIsShowModal) => {
  const settings = {
    title: 'Clasificados',
    currency: 'PEN',
    amount: price && Number(price.replace('.', '').replace(',', '')),
    order: data && data.order
  }

  const paymentMethods = {
    tarjeta: true,
    yape: false,
    billetera: false,
    bancaMovil: true,
    agente: true,
    cuotealo: false
  }

  const options = {
    lang: 'es',
    installments: false,
    modal: true,
    paymentMethods: paymentMethods,
    paymentMethodsSort: Object.keys(paymentMethods)
  }

  const userStorage = isClientEnv() && JSON.parse(localStorage.getItem('user'));

  const client = {
    email: userStorage.data && userStorage.data.email,
  }

  const appearance = {
    theme: 'default',
    hiddenCulqiLogo: false,
    hiddenBannerContent: false,
    hiddenBanner: false,
    hiddenToolBarAmount: false,
    hiddenEmail: false,
    menuType: 'sidebar',
    logo: `${process.env.PATH_STATIC}/logo-clasificados.png`
  }

  const config = {
    settings,
    client,
    options,
    appearance,
  };

  (window as any).Culqi = new CulqiCheckout(process.env.API_CULQUI_KEY, config);

  (window as any).Culqi.culqi = () => {
    try {
      if ((window as any).Culqi.error) {
        alert((window as any).Culqi.error.user_message);
        return;
      }
      let sendData = {};
      if ((window as any).Culqi.token) {
        sendData = {
          'token': (window as any).Culqi.token.id
        };
      }
      if (setIsShowModal) {
        setIsShowModal(true);
      }
      (window as any).Culqi.close();
      if ((window as any).paymentProcess) {
        (window as any).paymentProcess = false;
        dispatch(fetchProcessConfirmPayment(sendData));
      }
    } catch (e) {
      console.log('Error integration payment with culqi');
      dispatch(actionsModalError.openModalError());
      throw new Error(e);
    }
  };

  (window as any).Culqi.open();
}

export const sendDataPayment = (json, price: string, setIsShowModal) => {
  return async dispatch => {
    dispatch(sendDataPaymentRequest());
    await dispatch(fetchValidate());
    try {
      if (isClient) {
        const data = await paymentService.post(json);
        dispatch(sendDataPaymentSuccess(data));
        buildCulqiData(dispatch, data, price, setIsShowModal);
        (window as any).transaction = data;
      }
    } catch (error) {
      console.log('Error fetch payment', error);
      dispatch(actionsModalError.openModalError());
      dispatch(sendDataPaymentFailure());
    }
  }
}
